import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/img/logo.svg'
import _imports_1 from '@/assets/img/avatar.png'


const _hoisted_1 = { class: "min-h-screen flex overflow-hidden bg-gray-100" }
const _hoisted_2 = { class: "relative flex-1 flex flex-col w-3/4 pt-5 pb-4 bg-pri" }
const _hoisted_3 = { class: "absolute top-0 right-0 -mr-12 pt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 flex items-center px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-auto",
    src: _imports_0,
    alt: "Logo"
  })
], -1)
const _hoisted_6 = { class: "mt-5 flex-1 h-0 overflow-y-auto" }
const _hoisted_7 = { class: "p-3 space-y-1" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-shrink-0 w-14",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = { class: "hidden bg-pri md:flex md:flex-shrink-0 fixed min-h-screen" }
const _hoisted_11 = { class: "flex flex-col w-44" }
const _hoisted_12 = { class: "flex flex-col flex-grow pt-5 pb-4 overflow-y-auto" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center flex-shrink-0 px-4 mb-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-14 w-auto",
    src: _imports_0,
    alt: "Logo"
  })
], -1)
const _hoisted_14 = { class: "mt-5 flex-1 flex flex-col" }
const _hoisted_15 = { class: "flex-1 px-4 space-y-1" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "flex flex-col w-0 flex-1 overflow-hidden md:pl-[110px]" }
const _hoisted_18 = { class: "relative z-10 flex-shrink-0 flex h-16 bg-white shadow" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)
const _hoisted_20 = { class: "flex-1 p-10 px-9 flex items-center justify-between" }
const _hoisted_21 = { class: "flex-1 flex text-gray_500 text-2xl" }
const _hoisted_22 = { class: "w-full flex md:ml-0" }
const _hoisted_23 = { class: "ml-4 flex items-center md:ml-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-[4rem] w-[4rem] rounded-full object-cover",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex-1 relative overflow-y-auto focus:outline-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_MenuAlt2Icon = _resolveComponent("MenuAlt2Icon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.sidebarOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed inset-0 flex z-40 md:hidden",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarOpen = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-600 bg-opacity-75" })
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "transition ease-in-out duration-300 transform",
              "enter-from": "-translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transition ease-in-out duration-300 transform",
              "leave-from": "translate-x-0",
              "leave-to": "-translate-x-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_TransitionChild, {
                    as: "template",
                    enter: "ease-in-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in-out duration-300",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebarOpen = false))
                        }, [
                          _hoisted_4,
                          _createVNode(_component_XIcon, {
                            class: "h-6 w-6 text-white",
                            "aria-hidden": "true"
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("nav", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          to: item.href,
                          key: item.name
                        }, {
                          default: _withCtx(({ isActive }) => [
                            _createElementVNode("a", {
                              class: _normalizeClass([
                      isActive
                        ? 'bg-pri_light text-white'
                        : 'text-indigo-100 hover:pri_dark',
                      'group flex items-center !text-base font-medium rounded-md p-3',
                    ])
                            }, [
                              _createElementVNode("img", {
                                src: item.icon,
                                alt: item.name,
                                class: "mr-4 flex-shrink-0 text-indigo-300",
                                "aria-hidden": "true"
                              }, null, 8, _hoisted_8),
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("nav", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  to: item.href,
                  key: item.name
                }, {
                  default: _withCtx(({ isActive }) => [
                    _createElementVNode("a", {
                      class: _normalizeClass(["flex-col items-center justify-center mb-6 text-xl p-4", [
                    isActive
                      ? 'bg-pri_light text-white'
                      : 'text-indigo-100 hover:pri_dark',
                    'group flex items-center px-4 py-4 font-medium rounded-md',
                  ]])
                    }, [
                      _createElementVNode("img", {
                        src: item.icon,
                        alt: item.name,
                        class: "h-10 w-10 text-indigo-300 mb-4",
                        "aria-hidden": "true"
                      }, null, 8, _hoisted_16),
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          class: "px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-focus_border md:hidden",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sidebarOpen = true))
        }, [
          _hoisted_19,
          _createVNode(_component_MenuAlt2Icon, {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$route.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Menu, {
              as: "div",
              class: "ml-3 relative"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_MenuButton, { class: "max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-focus_border h-[4rem] w-[4rem]" }, {
                    default: _withCtx(() => [
                      _hoisted_24,
                      _hoisted_25
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-100",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                          return (_openBlock(), _createBlock(_component_MenuItem, {
                            as: "div",
                            key: item.name
                          }, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.handleUserNavigation(item.href)),
                                class: _normalizeClass([
                        active ? 'bg-gray-100' : '',
                        'block px-4 py-2 text-gray-700 cursor-pointer text-2xl',
                      ])
                              }, _toDisplayString(item.name), 11, _hoisted_26)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_27, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}